import React, { useState, useEffect } from "react";
import {
  getBankAccountInfoAction,
  resetServicesError,
  resetBankAccountDetails,
  resetServicesSucces,
} from "../../../redux/services";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { getBankAccountNumberType } from "../../../commonTypes/serviceTypes";
import { ServicesInput } from "../../../components/Services";
import { BankAccountInfoType } from "../../../redux/services/serviceTypes";
import { Loader, CommonHeader } from "../../../components/commons";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { GetPathBeforeClientCode } from "../../../components/commons/UserManagement";

type AppProps = {
  dispatchGetBankAccountInfo: (data: getBankAccountNumberType) => void;
  dispatchResetServicesError: () => void;
  dispatchResetBankAccountDetails: () => void;
  dispatchResetServicesSuccess: () => void;
  fetching: boolean;
  error: string | null;
  token: string | null;
  bankAccountDetails: BankAccountInfoType | null;
  history: any;
};

const GetBankAccountInfo = ({
  fetching,
  error,
  token,
  history,
  dispatchGetBankAccountInfo,
  dispatchResetServicesError,
  dispatchResetServicesSuccess,
  dispatchResetBankAccountDetails,
  bankAccountDetails,
}: AppProps) => {
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [ifscCode, setIfscCode] = useState<string>("");
  const [isBankAccountInfoUrlPresent, setIsBankAccountInfoUrlPresent] =
    useMenuCheck();
  const url = history?.location?.pathname;

  useEffect(() => {
    setIsBankAccountInfoUrlPresent(GetPathBeforeClientCode(url), "url");
    dispatchResetServicesError();
    dispatchResetBankAccountDetails();
    dispatchResetServicesSuccess();
  }, []);

  useEffect(() => {
    if (isBankAccountInfoUrlPresent === false) {
      history.push("/access-denied");
    }
  }, [isBankAccountInfoUrlPresent]);

  const getBankAccountInfo = () => {
    if (ifscCode && accountNumber && token) {
      let finalData = {
        ifsc_no: ifscCode,
        account_number: accountNumber,
        token,
      };
      dispatchGetBankAccountInfo(finalData);
    }
  };

  return (
    <div className="bank-account-info-wrap">
      <CommonHeader title="Bank Account Verification" />
      <div className="row">
        <div className="col-4">
          <ServicesInput
            serviceType={accountNumber}
            placeholder="Account Number"
            handleChange={(e) => setAccountNumber(e.target.value)}
            autoFocus
          />
          <ServicesInput
            serviceType={ifscCode}
            placeholder="IFSC Code"
            handleChange={(e) => setIfscCode(e.target.value)}
          />
          <button
            className="btn btn-primary w-100 mt-2"
            onClick={getBankAccountInfo}
            disabled={!accountNumber || !ifscCode}
          >
            Submit
          </button>
        </div>
        {bankAccountDetails ? (
          <div className="col-8">
            <table className="table table-bordered table-border-radius">
              <tbody>
                <tr>
                  <th style={{ width: "30%" }}>Account Exists</th>{" "}
                  <td className="centre">
                    {bankAccountDetails?.account_exists}
                  </td>
                </tr>

                <tr>
                  <th>Message</th>{" "}
                  <td className="branch">{bankAccountDetails?.message}</td>
                </tr>

                <tr>
                  <th>Name at Bank</th>{" "}
                  <td className="micr">{bankAccountDetails?.name_at_bank}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : error ? (
          <div className="col-8">
            <div className="card p-5 w-100">
              <h3 className="error">{!!error ? error : "No result Found!"}</h3>
            </div>
          </div>
        ) : null}
      </div>
      {fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.services.fetching,
  error: state.services.error,
  bankAccountDetails: state.services.bankAccountDetails,
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetBankAccountInfo: (data: getBankAccountNumberType) =>
    dispatch(getBankAccountInfoAction(data)),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
  dispatchResetBankAccountDetails: () => dispatch(resetBankAccountDetails()),
  dispatchResetServicesSuccess: () => dispatch(resetServicesSucces()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetBankAccountInfo);
